import { render, staticRenderFns } from "./userCollect.vue?vue&type=template&id=47b063b0&scoped=true"
import script from "./userCollect.vue?vue&type=script&lang=js"
export * from "./userCollect.vue?vue&type=script&lang=js"
import style0 from "./userCollect.vue?vue&type=style&index=0&id=47b063b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b063b0",
  null
  
)

export default component.exports